import { render, staticRenderFns } from "./SalesWebsite.vue?vue&type=template&id=435b3c1a&scoped=true"
import script from "./SalesWebsite.vue?vue&type=script&lang=js"
export * from "./SalesWebsite.vue?vue&type=script&lang=js"
import style0 from "./SalesWebsite.vue?vue&type=style&index=0&id=435b3c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b3c1a",
  null
  
)

export default component.exports